import { Drawer } from '@/new_src/view/components/Drawer/index';

import { mantineColors } from '@/theme/mantineColors';

// Mantine 기본 오버레이는 rgba(0, 0, 0, 0.6)이라 DS dim 토큰(Modal/Dim)과 어긋난다
export const DrawerResolver = Drawer.extend({
  defaultProps: {
    overlayProps: {
      color: mantineColors.gray[8],
      backgroundOpacity: 0.5,
    },
  },
});
